import { Select, SelectProps } from 'antd'
import React, { useCallback } from 'react'

import GroupTreeWithCheckboxList from '@/components/fields/group-tree-with-checkbox-list'
import { GroupType } from '@/model/group'
import { selectEmployeeOptions } from '@/redux/employee-selector'
import { useAppSelector } from '@/redux/utils'

import s from './employee-select.module.css'

export interface EmployeeSelectProps extends SelectProps<number[]> {
  value?: number[]
  onChange?: (value?: number[]) => void
}

export default function EmployeeSelect({
  value,
  onChange,
  ...restProps
}: EmployeeSelectProps) {
  const employeeOptions = useAppSelector(selectEmployeeOptions)
  const dropdownRender = useCallback(
    () => (
      <GroupTreeWithCheckboxList
        value={value}
        onChange={onChange}
        options={employeeOptions}
        type={GroupType.Employee}
      />
    ),
    [value, onChange, employeeOptions],
  )

  return (
    <Select<number[]>
      popupClassName={s.EmployeeSelect}
      placeholder="Select employee(s)"
      mode="multiple"
      value={value}
      onChange={onChange}
      dropdownRender={dropdownRender}
      options={employeeOptions}
      {...restProps}
    />
  )
}
